import ResetButton from 'src/common/filterTable/components/Buttons/ResetButton';
import SearchButton from 'src/common/filterTable/components/Buttons/SearchButton';
import FilterActions from 'src/common/filterTable/layout/FilterActions';
import { usePageConfigProviderContext } from '..';

const SearchAndResetBox = () => {
  const { onFilterSearch, onFilterReset } = usePageConfigProviderContext();
  return (
    <FilterActions>
      <SearchButton onSearch={onFilterSearch} />
      <ResetButton onReset={onFilterReset} />
    </FilterActions>
  );
};
export default SearchAndResetBox;
